import zxcvbn from 'zxcvbn';

export default {
  extendValidator(vue) {
    vue.$validator.extend('isStrong', value => ({
      valid: zxcvbn(value).score > 2,
      data: zxcvbn(value).feedback.warning,
    }));
    vue.$validator.extend('isSame', (confirm, [password]) => confirm === password, { hasTarget: true });
    vue.$validator.localize('en', {
      custom: {
        newPassword: {
          required: 'Please enter new password',
          isStrong: (fieldName, params, data) => data || 'Password is too easy to guess',
        },
        repeatNewPassword: {
          required: 'Please confirm your new password',
          isSame: 'Passwords do not match',
        },
      },
    });
    vue.$validator.extend('required_if', (value, [anotherFieldValue, testedValue]) =>
      anotherFieldValue !== testedValue || (anotherFieldValue === testedValue && value),
    { hasTarget: true });
  },
};




// WEBPACK FOOTER //
// ./src/utils/validation.js